import { createSelector } from '@ngrx/store';
import { PointOfSale } from '../../../models';
import { AppState } from '../app.state';

export const selectPointOfSale = createSelector(
  (state: AppState) => state.pointOfSale,
  (pointOfSale: PointOfSale) => pointOfSale
);
